import { render, staticRenderFns } from "./EditKeywords.vue?vue&type=template&id=223169f9&scoped=true"
import script from "./EditKeywords.vue?vue&type=script&lang=js"
export * from "./EditKeywords.vue?vue&type=script&lang=js"
import style0 from "./EditKeywords.vue?vue&type=style&index=0&id=223169f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223169f9",
  null
  
)

export default component.exports